jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });
});

// Pavan customized oos remover
document.querySelectorAll('.ssc-dropdown-toggle').forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();

    // Close all other menus
    document.querySelectorAll('.ssc-dropdown-menu').forEach(menu => {
      if (menu !== this.nextElementSibling) {
        menu.style.display = 'none';
      }
    });

    // Toggle the current menu
    const menu = this.nextElementSibling;
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
  });
});

// Close dropdown if clicked outside
window.addEventListener('click', function (e) {
  if (!e.target.closest('.ssc-dropdown')) {
    document.querySelectorAll('.ssc-dropdown-menu').forEach(menu => {
      menu.style.display = 'none';
    });
  }
});

// end
